import { render, staticRenderFns } from "./CountryComparison.vue?vue&type=template&id=378d77f2&"
import script from "./CountryComparison.vue?vue&type=script&lang=js&"
export * from "./CountryComparison.vue?vue&type=script&lang=js&"
import style0 from "./CountryComparison.vue?vue&type=style&index=0&id=378d77f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports